import config from 'config';
import { Country, State } from 'country-state-city';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { fromPromise } from 'neverthrow';
import superAgent from 'superagent';

const { API } = config;

const HERE_API_KEY = process.env.REACT_APP_HERE_API_KEY;

countries.registerLocale(enLocale);

const countryObj = countries.getNames('en', { select: 'official' });

export const countryList = Object.entries(countryObj).map(([key, value]) => {
    return {
        label: value,
        value: countries.alpha2ToAlpha3(key),
    };
});

// Same list as above but keyed by alpha-2, which is what Stripe expects for a
// billing address. Sorted by name so the picker reads sensibly.
export const countryListAlpha2 = Object.entries(countryObj)
    .map(([code, name]) => ({ label: name, value: code }))
    .sort((a, b) => a.label.localeCompare(b.label));

export const getUserAddress = async ({ zipCode, countryCode }) => {
    const response = await fromPromise(
        superAgent('get', API.HERE_GEOCODE_URL).query({
            apiKey: HERE_API_KEY,
            qq: `postalCode=${zipCode};country=${countryCode}`,
        }),
        (error) => error
    );

    if (response.isOk()) {
        const value = response.value.body;

        const userAddress = value.items?.[0]?.address ?? {};

        return userAddress;
    }
};

export const countryCodeToCountryName = (code) => {
    return countryList.find((country) => country.value === code)?.label ?? code;
};

export const countryNameToCode = (name) =>
    countryList.find((country) => country.label.toLowerCase() === name?.toLowerCase())?.value ??
    name;

export const getAllCountries = () => {
    return Country.getAllCountries();
};

export const getStateFromCountry = (country) => {
    // if we get country name, we need to find the country by name first
    // if we get country code, we find by ISO code
    let targetCountry;

    if (country) {
        // Try to find by ISO code first
        targetCountry = Country.getAllCountries().find(
            (c) => c.isoCode === country || c.isoCode === countryNameToCode(country)
        );

        // If not found, try by name
        if (!targetCountry) {
            targetCountry = Country.getAllCountries().find(
                (c) => c.name.toLowerCase() === country.toLowerCase()
            );
        }
    }

    return targetCountry ? State.getStatesOfCountry(targetCountry.isoCode) : [];
};

// get state list of country that is currently selected
export const getStateList = (countryInput) => {
    if (!countryInput) return [];
    const countryValue = countryInput?.value;

    // convert country value to alpha2 code because the package we are using recognized only two character country code
    const countryAlpha2Code = countries.alpha3ToAlpha2(countryValue);

    const states = State.getStatesOfCountry(countryAlpha2Code).map((state) => ({
        label: `${state.name} (${state.isoCode})`,
        value: state.isoCode,
    }));

    return states;
};
